var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { createCheckoutSession } from '@/lib/subscription';
import { useI18n } from '@/lib/i18n';
import * as styles from './UpgradeModal.module.scss';
export var UpgradeModal = function (_a) {
    var onClose = _a.onClose;
    var _b = useI18n(), t = _b.t, locale = _b.locale;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var proFeatures = [
        { icon: '👥', title: t.unlimitedClients, desc: t.unlimitedDesc },
        { icon: '🎨', title: t.customBranding, desc: t.customBrandingDesc },
        { icon: '⚡', title: t.prioritySupport, desc: t.prioritySupportDesc },
    ];
    var handleUpgrade = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createCheckoutSession()];
                case 2:
                    url = _a.sent();
                    if (url) {
                        window.location.href = url;
                    }
                    else {
                        alert(t.paymentTryLater);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error('Checkout error:', err_1);
                    alert(t.paymentError);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var stayLabel = locale === 'ru' ? 'Остаться на Free' : 'Stay on Free';
    var redirectLabel = locale === 'ru' ? 'Переход к оплате...' : 'Redirecting...';
    var subscribeLabel = locale === 'ru' ? '💳 Оформить подписку' : '💳 Subscribe';
    var limitLabel = locale === 'ru'
        ? 'Вы достигли лимита бесплатного плана (1 клиент). Перейдите на Pro чтобы снять ограничения.'
        : 'You have reached the free plan limit (1 client). Upgrade to Pro to remove restrictions.';
    var cancelAnytime = locale === 'ru' ? 'Отмена в любой момент' : 'Cancel anytime';
    var footerLabel = locale === 'ru' ? 'Оплата через Stripe · Безопасно · Тестовый режим' : 'Payment via Stripe · Secure · Test mode';
    return (_jsx("div", { className: styles.overlay, onClick: onClose, children: _jsxs("div", { className: styles.modal, onClick: function (e) { return e.stopPropagation(); }, children: [_jsx("div", { className: styles.badge, children: "PRO" }), _jsx("div", { className: styles.title, children: t.upgradeTo }), _jsx("div", { className: styles.subtitle, children: limitLabel }), _jsx("div", { className: styles.features, children: proFeatures.map(function (f) { return (_jsxs("div", { className: styles.feature, children: [_jsx("div", { className: styles.featureIcon, children: f.icon }), _jsxs("div", { className: styles.featureContent, children: [_jsx("div", { className: styles.featureTitle, children: f.title }), _jsx("div", { className: styles.featureDesc, children: f.desc })] })] }, f.title)); }) }), _jsxs("div", { className: styles.priceBlock, children: [_jsxs("div", { className: styles.price, children: [_jsx("span", { className: styles.priceAmount, children: "4$" }), _jsx("span", { className: styles.pricePeriod, children: locale === 'ru' ? '/мес' : '/mo' })] }), _jsx("div", { className: styles.priceHint, children: cancelAnytime })] }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { className: styles.upgradeBtn, onClick: handleUpgrade, disabled: loading, children: loading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.spinner }), redirectLabel] })) : subscribeLabel }), _jsx("button", { className: styles.cancelBtn, onClick: onClose, children: stayLabel })] }), _jsx("div", { className: styles.footer, children: footerLabel })] }) }));
};
